import { Box } from "@mui/material";
import { Form, Formik } from "formik";
import React from "react";
import { TextInputComponent } from "../../../../../../common/components";
import { updateTenetDetails } from "../../../../../../api/tenets";
import { EditBasicAddressProps } from "../../../tenant-details-types";
import * as Yup from "yup";
import AddressFormFields from "../../../../../../common/components/address-form-fields/address-form-fields";

const defaultInitialValues = {
  streetLine1: "",
  streetLine2: "",
  city: "",
  state: "",
  postcode: "",
  country: "",
};
const EditBasicAddress: React.FC<EditBasicAddressProps> = ({
  data,
  formRef,
  type,
  handleSuccessApi,
  initialValues = defaultInitialValues,
  handleError,
}) => {
  const addressId =
    type === "billing" ? data?.billing_address?.id : data?.company_address?.id;

  const addressValidation = Yup.object().shape({
    streetLine1: Yup.string()
      .trim()
      .min(3, "Street line 1 must be at least 3 characters"),
    streetLine2: Yup.string()
      .trim()
      .min(3, "Street line 2 must be at least 3 characters"),
    city: Yup.string().trim(),
    state: Yup.string().trim(),
    country: Yup.string().trim(),
    postcode: Yup.string()
      .trim()
      .matches(/^\d{4,10}$/, "Enter a valid postcode"),
  });

  const handleUpdateAddress = async (values: any) => {
    try {
      const response = await updateTenetDetails(Number(data.id), "address", {
        id: addressId,
        streetLine1: values?.streetLine1,
        streetLine2: values?.streetLine2,
        city: values?.city,
        state: values?.state,
        postcode: values?.postcode,
        country: values?.country,
      });
      if (response?.data?.success) {
        if (handleSuccessApi) handleSuccessApi(response?.data?.data);
      }
    } catch (error) {
      handleError(error);
      console.error("Error updating address:", error);
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validateOnBlur
        onSubmit={handleUpdateAddress}
        validationSchema={addressValidation}
        enableReinitialize
        innerRef={(instance) => {
          if (formRef && instance) {
            formRef.current = instance;
          }
        }}
      >
        {({ handleChange, values }) => (
          <Form>
            <AddressFormFields isOutlineInputs />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EditBasicAddress;
